// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#chat[data-v-7d872e50]{display:-webkit-box;display:-ms-flexbox;display:flex;width:calc(100% - 258px)}.user-details-enter[data-v-7d872e50],.user-details-leave-to[data-v-7d872e50]{width:0!important}", ""]);
// Exports
module.exports = exports;
